/* tslint:disable */
/* eslint-disable */
/**
 * Api TLR
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import type {ExtendedAxiosRequestConfig} from './common';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, setBearerAuthToFormData } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

export const defaultExtendedAxiosRequestConfig : ExtendedAxiosRequestConfig = {extensions: {}}

/**
 * 
 * @export
 * @interface AdjuntoOscilo
 */
export interface AdjuntoOscilo {
    /**
     * 
     * @type {number}
     * @memberof AdjuntoOscilo
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoOscilo
     */
    'NombreFichero': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoOscilo
     */
    'GuidSubida': string | null;
}
/**
 * 
 * @export
 * @interface AdjuntoSuceso
 */
export interface AdjuntoSuceso {
    /**
     * 
     * @type {number}
     * @memberof AdjuntoSuceso
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoSuceso
     */
    'NombreFichero': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdjuntoSuceso
     */
    'GuidSubida': string | null;
}
/**
 * 
 * @export
 * @interface BooleanResponseDTO
 */
export interface BooleanResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof BooleanResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof BooleanResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BooleanResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof BooleanResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResponseDTO
     */
    'Data'?: boolean;
    /**
     * 
     * @type {any}
     * @memberof BooleanResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface CreateOsciloModel
 */
export interface CreateOsciloModel {
    /**
     * 
     * @type {string}
     * @memberof CreateOsciloModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOsciloModel
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOsciloModel
     */
    'NombreEmpresaInstalacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateOsciloModel
     */
    'FechaInstalacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOsciloModel
     */
    'IpPublica': string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateOsciloModel
     */
    'Puerto': number;
    /**
     * 
     * @type {number}
     * @memberof CreateOsciloModel
     */
    'FrecuenciaDescargaEnMinutos': number;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOsciloModel
     */
    'DescargaHabilitada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateOsciloModel
     */
    'EnStandby': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateOsciloModel
     */
    'IdInstalacion': number;
    /**
     * 
     * @type {Array<AdjuntoOscilo>}
     * @memberof CreateOsciloModel
     */
    'Adjuntos': Array<AdjuntoOscilo>;
}
/**
 * 
 * @export
 * @interface CreateSucesoModel
 */
export interface CreateSucesoModel {
    /**
     * 
     * @type {Date}
     * @memberof CreateSucesoModel
     */
    'FechaHora': Date;
    /**
     * 
     * @type {string}
     * @memberof CreateSucesoModel
     */
    'RutaFichero': string;
    /**
     * 
     * @type {string}
     * @memberof CreateSucesoModel
     */
    'Comentarios': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateSucesoModel
     */
    'Wiki': boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateSucesoModel
     */
    'IdTipo': number;
    /**
     * 
     * @type {number}
     * @memberof CreateSucesoModel
     */
    'IdCategoriaTipo': number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateSucesoModel
     */
    'IdOscilo': number;
}
/**
 * 
 * @export
 * @interface CreateUserModel
 */
export interface CreateUserModel {
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'UserName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Telefono': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserModel
     */
    'Rol': string;
}
/**
 * 
 * @export
 * @interface DXLoadOptions
 */
export interface DXLoadOptions {
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireTotalCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'requireGroupCount'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isCountQuery'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'isSummaryQuery'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'skip'?: number;
    /**
     * 
     * @type {number}
     * @memberof DXLoadOptions
     */
    'take'?: number;
    /**
     * 
     * @type {Array<SortingInfo>}
     * @memberof DXLoadOptions
     */
    'sort'?: Array<SortingInfo> | null;
    /**
     * 
     * @type {Array<GroupingInfo>}
     * @memberof DXLoadOptions
     */
    'group'?: Array<GroupingInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'totalSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<SummaryInfo>}
     * @memberof DXLoadOptions
     */
    'groupSummary'?: Array<SummaryInfo> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'select'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'preSelect'?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteSelect'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'remoteGrouping'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'expandLinqSumType'?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof DXLoadOptions
     */
    'primaryKey'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof DXLoadOptions
     */
    'defaultSort'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'stringToLower'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'paginateViaPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'sortByPrimaryKey'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof DXLoadOptions
     */
    'allowAsyncOverSync'?: boolean;
    /**
     * 
     * @type {Array<any>}
     * @memberof DXLoadOptions
     */
    'filter'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface DefaultResponseDTO
 */
export interface DefaultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof DefaultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof DefaultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DefaultResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'CorrelationId'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatus = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    UnhandledException: 'UnhandledException',
    InvalidArguments: 'InvalidArguments',
    ConcurrencyError: 'ConcurrencyError',
    OutOfService: 'OutOfService',
    Unauthorized: 'Unauthorized'
} as const;

export type DefaultResponseStatus = typeof DefaultResponseStatus[keyof typeof DefaultResponseStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const DefaultResponseStatusCategory = {
    NotSet: 'NotSet',
    Ok: 'Ok',
    TransientError: 'TransientError',
    PermanentError: 'PermanentError'
} as const;

export type DefaultResponseStatusCategory = typeof DefaultResponseStatusCategory[keyof typeof DefaultResponseStatusCategory];


/**
 * 
 * @export
 * @interface DeleteOsciloModel
 */
export interface DeleteOsciloModel {
    /**
     * 
     * @type {number}
     * @memberof DeleteOsciloModel
     */
    'Id': number;
}
/**
 * 
 * @export
 * @interface DeleteUserModel
 */
export interface DeleteUserModel {
    /**
     * 
     * @type {number}
     * @memberof DeleteUserModel
     */
    'IdUsuario': number;
}
/**
 * 
 * @export
 * @interface EditInstalacionModel
 */
export interface EditInstalacionModel {
    /**
     * 
     * @type {number}
     * @memberof EditInstalacionModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof EditInstalacionModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof EditInstalacionModel
     */
    'Latitud': number;
    /**
     * 
     * @type {number}
     * @memberof EditInstalacionModel
     */
    'Longitud': number;
    /**
     * 
     * @type {number}
     * @memberof EditInstalacionModel
     */
    'IdZona': number;
}
/**
 * 
 * @export
 * @interface EditOsciloModel
 */
export interface EditOsciloModel {
    /**
     * 
     * @type {number}
     * @memberof EditOsciloModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof EditOsciloModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof EditOsciloModel
     */
    'NumeroSerie': string | null;
    /**
     * 
     * @type {string}
     * @memberof EditOsciloModel
     */
    'NombreEmpresaInstalacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof EditOsciloModel
     */
    'FechaInstalacion': Date | null;
    /**
     * 
     * @type {string}
     * @memberof EditOsciloModel
     */
    'IpPublica': string | null;
    /**
     * 
     * @type {number}
     * @memberof EditOsciloModel
     */
    'Puerto': number;
    /**
     * 
     * @type {number}
     * @memberof EditOsciloModel
     */
    'FrecuenciaDescargaEnMinutos': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditOsciloModel
     */
    'DescargaHabilitada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EditOsciloModel
     */
    'EnStandby': boolean;
    /**
     * 
     * @type {number}
     * @memberof EditOsciloModel
     */
    'IdInstalacion': number;
    /**
     * 
     * @type {Array<AdjuntoOscilo>}
     * @memberof EditOsciloModel
     */
    'Adjuntos': Array<AdjuntoOscilo>;
}
/**
 * 
 * @export
 * @interface EditSucesoModel
 */
export interface EditSucesoModel {
    /**
     * 
     * @type {number}
     * @memberof EditSucesoModel
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof EditSucesoModel
     */
    'IdSucesoTipo': number;
    /**
     * 
     * @type {number}
     * @memberof EditSucesoModel
     */
    'IdSucesoCategoriaTipo': number;
    /**
     * 
     * @type {boolean}
     * @memberof EditSucesoModel
     */
    'Wiki': boolean;
    /**
     * 
     * @type {string}
     * @memberof EditSucesoModel
     */
    'Comentarios': string | null;
    /**
     * 
     * @type {Array<AdjuntoSuceso>}
     * @memberof EditSucesoModel
     */
    'Adjuntos': Array<AdjuntoSuceso>;
}
/**
 * 
 * @export
 * @interface EditUserModel
 */
export interface EditUserModel {
    /**
     * 
     * @type {number}
     * @memberof EditUserModel
     */
    'IdUsuario': number;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Nombre'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Apellidos'?: string;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Telefono'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUserModel
     */
    'Rol'?: string;
}
/**
 * 
 * @export
 * @interface EditZonaModel
 */
export interface EditZonaModel {
    /**
     * 
     * @type {number}
     * @memberof EditZonaModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof EditZonaModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof EditZonaModel
     */
    'IdRegion': number;
    /**
     * 
     * @type {number}
     * @memberof EditZonaModel
     */
    'IdUsuarioJefe': number;
}
/**
 * 
 * @export
 * @interface FicheroMedidaDetalleModel
 */
export interface FicheroMedidaDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'RutaFicheroCfg': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'RutaFicheroDat': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'RutaFicheroHdr': string;
    /**
     * 
     * @type {Date}
     * @memberof FicheroMedidaDetalleModel
     */
    'FechaPrimeraMedida': Date;
    /**
     * 
     * @type {Date}
     * @memberof FicheroMedidaDetalleModel
     */
    'FechaDisparo': Date;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdSuceso': number;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdSucesoTipo': number;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'NumeroSucesoTipo': number;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'NombreSucesoTipo': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'DescripcionSucesoTipo': string;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdSucesoCategoriaTipo': number;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'NombreSucesoCategoriaTipo': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'DescripcionSucesoCategoriaTipo': string;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdOscilo': number;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'NombreOscilo': string;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdInstalacion': number;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'NombreInstalacion': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'CodigoZonaHorariaInstalacion': string;
    /**
     * 
     * @type {Date}
     * @memberof FicheroMedidaDetalleModel
     */
    'FechaHora': Date;
    /**
     * 
     * @type {boolean}
     * @memberof FicheroMedidaDetalleModel
     */
    'TieneFicheroMedidas': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FicheroMedidaDetalleModel
     */
    'TieneAdjuntos': boolean;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'RutaFichero': string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModel
     */
    'Comentarios': string;
    /**
     * 
     * @type {boolean}
     * @memberof FicheroMedidaDetalleModel
     */
    'Wiki': boolean;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof FicheroMedidaDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof FicheroMedidaDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof FicheroMedidaDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof FicheroMedidaDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface FicheroMedidaDetalleModelListResponseDTO
 */
export interface FicheroMedidaDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<FicheroMedidaDetalleModel>}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'Data'?: Array<FicheroMedidaDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof FicheroMedidaDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface GroupingInfo
 */
export interface GroupingInfo {
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'desc'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GroupingInfo
     */
    'groupInterval'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupingInfo
     */
    'isExpanded'?: boolean | null;
}
/**
 * 
 * @export
 * @interface InstalacionDetalleModel
 */
export interface InstalacionDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'NombreCompleto': string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'NombreInstalacionTipo': string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'DescripcionInstalacionTipo': string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'NombreProvincia': string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'NombreComunidadAutonoma': string;
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'IdZona': number;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'NombreZona': string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModel
     */
    'CodigoZonaHorariaInstalacion': string;
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'Latitud': number;
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'Longitud': number;
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof InstalacionDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof InstalacionDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof InstalacionDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof InstalacionDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface InstalacionDetalleModelListResponseDTO
 */
export interface InstalacionDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<InstalacionDetalleModel>}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'Data'?: Array<InstalacionDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof InstalacionDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface Int32ResponseDTO
 */
export interface Int32ResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof Int32ResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof Int32ResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Int32ResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Int32ResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof Int32ResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {number}
     * @memberof Int32ResponseDTO
     */
    'Data'?: number;
    /**
     * 
     * @type {any}
     * @memberof Int32ResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface LoadResult
 */
export interface LoadResult {
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'data'?: Array<any> | null;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'totalCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof LoadResult
     */
    'groupCount'?: number;
    /**
     * 
     * @type {Array<any>}
     * @memberof LoadResult
     */
    'summary'?: Array<any> | null;
}
/**
 * 
 * @export
 * @interface LoadResultResponseDTO
 */
export interface LoadResultResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof LoadResultResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof LoadResultResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof LoadResultResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof LoadResultResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoadResultResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof LoadResultResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {LoadResult}
     * @memberof LoadResultResponseDTO
     */
    'Data'?: LoadResult;
    /**
     * 
     * @type {any}
     * @memberof LoadResultResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ObjectResponseDTO
 */
export interface ObjectResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ObjectResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ObjectResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ObjectResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ObjectResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ObjectResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {any}
     * @memberof ObjectResponseDTO
     */
    'Data'?: any;
    /**
     * 
     * @type {any}
     * @memberof ObjectResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OsciloDetalleModel
 */
export interface OsciloDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'IdInstalacion': number;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'NombreInstalacion': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'NombreCompletoInstalacion': string;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'LatitudInstalacion': number;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'LongitudInstalacion': number;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'CodigoZonaHorariaInstalacion': string;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'IdOsciloEstadoTipo': number;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'NumeroSerie': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'NombreEmpresaInstalacion': string | null;
    /**
     * 
     * @type {Date}
     * @memberof OsciloDetalleModel
     */
    'FechaInstalacion': Date;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'IpPublica': string;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'Puerto': number;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'FrecuenciaDescargaEnMinutos': number;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModel
     */
    'DescargaHabilitada': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModel
     */
    'EnStandby': boolean;
    /**
     * 
     * @type {Date}
     * @memberof OsciloDetalleModel
     */
    'FechaUltimoIntentoDescarga': Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModel
     */
    'UltimoIntentoDescargaCompletado': boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModel
     */
    'UltimoIntentoDescargaCorrecto': boolean | null;
    /**
     * 
     * @type {Date}
     * @memberof OsciloDetalleModel
     */
    'FechaUltimoFicheroDescargado': Date | null;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'NumeroReintentoEnCurso': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModel
     */
    'TieneAdjuntos': boolean;
    /**
     * 
     * @type {Array<ReferenciaFicheroModel>}
     * @memberof OsciloDetalleModel
     */
    'Adjuntos': Array<ReferenciaFicheroModel>;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof OsciloDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof OsciloDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof OsciloDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof OsciloDetalleModel
     */
    'FechaBaja': Date | null;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'NombreJefeZona': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'TelefonoJefeZona': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'EmailJefeZona': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModel
     */
    'NombreZonaInstalacion': string | null;
}
/**
 * 
 * @export
 * @interface OsciloDetalleModelResponseDTO
 */
export interface OsciloDetalleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {OsciloDetalleModel}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'Data'?: OsciloDetalleModel;
    /**
     * 
     * @type {any}
     * @memberof OsciloDetalleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface OsciloEstadoTipoDetalleModel
 */
export interface OsciloEstadoTipoDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof OsciloEstadoTipoDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof OsciloEstadoTipoDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof OsciloEstadoTipoDetalleModel
     */
    'Descripcion': string;
}
/**
 * 
 * @export
 * @interface OsciloEstadoTipoDetalleModelListResponseDTO
 */
export interface OsciloEstadoTipoDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<OsciloEstadoTipoDetalleModel>}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'Data'?: Array<OsciloEstadoTipoDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof OsciloEstadoTipoDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ReferenciaFicheroModel
 */
export interface ReferenciaFicheroModel {
    /**
     * 
     * @type {number}
     * @memberof ReferenciaFicheroModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ReferenciaFicheroModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof ReferenciaFicheroModel
     */
    'Tamano': number;
}
/**
 * 
 * @export
 * @interface RegionDetalleModel
 */
export interface RegionDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof RegionDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof RegionDetalleModel
     */
    'Nombre': string;
}
/**
 * 
 * @export
 * @interface RegionDetalleModelListResponseDTO
 */
export interface RegionDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<RegionDetalleModel>}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'Data'?: Array<RegionDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof RegionDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface RolesRm
 */
export interface RolesRm {
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'Id': string;
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'Name': string;
    /**
     * 
     * @type {string}
     * @memberof RolesRm
     */
    'NormalizedName': string;
}
/**
 * 
 * @export
 * @interface RolesRmListResponseDTO
 */
export interface RolesRmListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof RolesRmListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof RolesRmListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof RolesRmListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RolesRmListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RolesRmListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof RolesRmListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<RolesRm>}
     * @memberof RolesRmListResponseDTO
     */
    'Data'?: Array<RolesRm>;
    /**
     * 
     * @type {any}
     * @memberof RolesRmListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SortingInfo
 */
export interface SortingInfo {
    /**
     * 
     * @type {string}
     * @memberof SortingInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SortingInfo
     */
    'desc'?: boolean;
}
/**
 * 
 * @export
 * @interface StringResponseDTO
 */
export interface StringResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof StringResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof StringResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof StringResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof StringResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {string}
     * @memberof StringResponseDTO
     */
    'Data'?: string;
    /**
     * 
     * @type {any}
     * @memberof StringResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SucesoCategoriaTipoDetalleModel
 */
export interface SucesoCategoriaTipoDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoCategoriaTipoDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface SucesoCategoriaTipoDetalleModelListResponseDTO
 */
export interface SucesoCategoriaTipoDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SucesoCategoriaTipoDetalleModel>}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'Data'?: Array<SucesoCategoriaTipoDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof SucesoCategoriaTipoDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SucesoDetalleModel
 */
export interface SucesoDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdSucesoTipo': number;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'NumeroSucesoTipo': number;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'NombreSucesoTipo': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'DescripcionSucesoTipo': string;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdSucesoCategoriaTipo': number;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'NombreSucesoCategoriaTipo': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'DescripcionSucesoCategoriaTipo': string;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdOscilo': number;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'NombreOscilo': string;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdInstalacion': number;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'NombreInstalacion': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'NombreCompletoInstalacion': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'CodigoZonaHorariaInstalacion': string;
    /**
     * 
     * @type {Date}
     * @memberof SucesoDetalleModel
     */
    'FechaHora': Date;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoDetalleModel
     */
    'TieneFicheroMedidas': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoDetalleModel
     */
    'TieneAdjuntos': boolean;
    /**
     * 
     * @type {Array<ReferenciaFicheroModel>}
     * @memberof SucesoDetalleModel
     */
    'Adjuntos': Array<ReferenciaFicheroModel>;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModel
     */
    'Comentarios': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoDetalleModel
     */
    'Wiki': boolean;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof SucesoDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface SucesoDetalleModelResponseDTO
 */
export interface SucesoDetalleModelResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {SucesoDetalleModel}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'Data'?: SucesoDetalleModel;
    /**
     * 
     * @type {any}
     * @memberof SucesoDetalleModelResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SucesoTipoDetalleModel
 */
export interface SucesoTipoDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof SucesoTipoDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof SucesoTipoDetalleModel
     */
    'Numero': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoTipoDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof SucesoTipoDetalleModel
     */
    'Descripcion': string;
    /**
     * 
     * @type {number}
     * @memberof SucesoTipoDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoTipoDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof SucesoTipoDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoTipoDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof SucesoTipoDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof SucesoTipoDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface SucesoTipoDetalleModelListResponseDTO
 */
export interface SucesoTipoDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<SucesoTipoDetalleModel>}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'Data'?: Array<SucesoTipoDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof SucesoTipoDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface SummaryInfo
 */
export interface SummaryInfo {
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'selector'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SummaryInfo
     */
    'summaryType'?: string | null;
}
/**
 * 
 * @export
 * @interface UserProfileResponse
 */
export interface UserProfileResponse {
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'Username': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'FirstName': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'LastName': string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponse
     */
    'Email': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserProfileResponse
     */
    'Permissions': Array<string>;
}
/**
 * 
 * @export
 * @interface UserProfileResponseResponseDTO
 */
export interface UserProfileResponseResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UserProfileResponseResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UserProfileResponseResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponseResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserProfileResponseResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponseResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserProfileResponseResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {UserProfileResponse}
     * @memberof UserProfileResponseResponseDTO
     */
    'Data'?: UserProfileResponse;
    /**
     * 
     * @type {any}
     * @memberof UserProfileResponseResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface UsuarioDetalleModel
 */
export interface UsuarioDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof UsuarioDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {number}
     * @memberof UsuarioDetalleModel
     */
    'IdUsuario': number;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'UserName': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'IdentityId': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'Apellidos': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'NombreCompleto': string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'Email': string | null;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'Telefono': string | null;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModel
     */
    'Rol': string;
    /**
     * 
     * @type {number}
     * @memberof UsuarioDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof UsuarioDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof UsuarioDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof UsuarioDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof UsuarioDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof UsuarioDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface UsuarioDetalleModelListResponseDTO
 */
export interface UsuarioDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<UsuarioDetalleModel>}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'Data'?: Array<UsuarioDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof UsuarioDetalleModelListResponseDTO
     */
    'Extra'?: any;
}


/**
 * 
 * @export
 * @interface ZonaDetalleModel
 */
export interface ZonaDetalleModel {
    /**
     * 
     * @type {number}
     * @memberof ZonaDetalleModel
     */
    'Id': number;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'Nombre': string;
    /**
     * 
     * @type {number}
     * @memberof ZonaDetalleModel
     */
    'IdRegion': number;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'NombreRegion': string;
    /**
     * 
     * @type {number}
     * @memberof ZonaDetalleModel
     */
    'IdUsuarioJefe': number;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'NombreUsuarioJefe': string;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'ApellidosUsuarioJefe': string;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'TelefonoUsuarioJefe': string | null;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'EmailUsuarioJefe': string;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModel
     */
    'UsuarioJefe': string;
    /**
     * 
     * @type {number}
     * @memberof ZonaDetalleModel
     */
    'IdUsuarioCreacion': number;
    /**
     * 
     * @type {Date}
     * @memberof ZonaDetalleModel
     */
    'FechaCreacion': Date;
    /**
     * 
     * @type {number}
     * @memberof ZonaDetalleModel
     */
    'IdUsuarioUltimaModificacion': number;
    /**
     * 
     * @type {Date}
     * @memberof ZonaDetalleModel
     */
    'FechaUltimaModificacion': Date;
    /**
     * 
     * @type {number}
     * @memberof ZonaDetalleModel
     */
    'IdUsuarioBaja': number;
    /**
     * 
     * @type {Date}
     * @memberof ZonaDetalleModel
     */
    'FechaBaja': Date | null;
}
/**
 * 
 * @export
 * @interface ZonaDetalleModelListResponseDTO
 */
export interface ZonaDetalleModelListResponseDTO {
    /**
     * 
     * @type {DefaultResponseStatusCategory}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'StatusCategory'?: DefaultResponseStatusCategory;
    /**
     * 
     * @type {DefaultResponseStatus}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'Status'?: DefaultResponseStatus;
    /**
     * 
     * @type {boolean}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'Ok'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'IsTransient'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'Message'?: string;
    /**
     * 
     * @type {string}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'CorrelationId'?: string;
    /**
     * 
     * @type {Array<ZonaDetalleModel>}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'Data'?: Array<ZonaDetalleModel>;
    /**
     * 
     * @type {any}
     * @memberof ZonaDetalleModelListResponseDTO
     */
    'Extra'?: any;
}



  
export const ApiApiRoutes = {
    apiHelpAsociarOsciloRegGet: "/api/help/asociar_oscilo.reg",
    apiHelpAsociarSigraRegGet: "/api/help/asociar_sigra.reg",
    featuresGet: "/features/{featureName}",
    featuresList: "/features",
    ficheroMedidaDownload: "/api/Commons/FicheroMedida/download",
    ficheroMedidaDownloadZip: "/api/Commons/FicheroMedida/downloadZip",
    ficheroMedidaGetBySuceso: "/api/Commons/Suceso/{id}/ficheros-medida/detalle",
    ficheroMedidaGetRejilla: "/api/Commons/FicheroMedida/rejilla",
    instalacionEdit: "/api/Commons/Instalacion/Editar",
    instalacionGetRejilla: "/api/Commons/Instalacion/rejilla",
    instalacionGetTodas: "/api/Commons/Instalacion",
    osciloAttachmentDownload: "/api/Commons/Oscilo/{id}/adjunto/{idAdjunto}",
    osciloAttachmentUpload: "/api/Commons/Oscilo/{id}/adjunto",
    osciloCheckIpPort: "/api/Commons/Oscilo/CheckAvailability/IpPort",
    osciloCheckIpPublica: "/api/Commons/Oscilo/CheckAvailability/PublicIP",
    osciloCheckNombre: "/api/Commons/Oscilo/CheckAvailability/Name",
    osciloCheckNumeroSerie: "/api/Commons/Oscilo/CheckAvailability/SerialNumber",
    osciloCreate: "/api/Commons/Oscilo",
    osciloDelete: "/api/Commons/Oscilo/Eliminar",
    osciloEdit: "/api/Commons/Oscilo/Editar",
    osciloEncolarPeticionManualDescarga: "/api/Commons/Oscilo/EncolarPeticionManualDescarga/{idOscilo}",
    osciloEstadoTipoGetTodos: "/api/Commons/OsciloEstadoTipo",
    osciloGetDetalle: "/api/Commons/Oscilo/{id}/detalle",
    osciloGetRejilla: "/api/Commons/Oscilo/rejilla",
    regionGetTodas: "/api/Commons/Region",
    rolesGetAll: "/api/Commons/Usuario/Roles",
    sucesoAttachmentDownload: "/api/Commons/Suceso/{id}/adjunto/{idAdjunto}",
    sucesoAttachmentUpload: "/api/Commons/Suceso/{id}/adjunto",
    sucesoCategoriaTipoGetTodos: "/api/Commons/SucesoCategoriaTipo",
    sucesoCreate: "/api/Commons/Suceso",
    sucesoEdit: "/api/Commons/Suceso/Editar",
    sucesoGetDetalle: "/api/Commons/Suceso/{id}/detalle",
    sucesoGetRejilla: "/api/Commons/Suceso/rejilla",
    sucesoTipoGetTodos: "/api/Commons/SucesoTipo",
    usuarioCheckEmail: "/api/Commons/Usuario/{Email}/{IdUsuario}/EmailAvailable",
    usuarioCheckUsername: "/api/Commons/Usuario/{Username}/Available",
    usuarioCreate: "/api/Commons/Usuario",
    usuarioDelete: "/api/Commons/Usuario/Eliminar",
    usuarioEdit: "/api/Commons/Usuario/Editar",
    usuarioGetCurrentUserProfile: "/api/Commons/Usuario/me/Profile",
    usuarioGetRejilla: "/api/Commons/Usuario/Rejilla",
    usuarioGetTodos: "/api/Commons/Usuario",
    zonaEdit: "/api/Commons/Zona/Editar",
    zonaGetRejilla: "/api/Commons/Zona/rejilla",
    zonaGetTodas: "/api/Commons/Zona",
}
  
/**
 * ApiApi - axios parameter creator
 * @export
 */
export const ApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
  

         
      
      
        /**
         * 
         * @param {string} [FileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHelpAsociarOsciloRegGet: async (FileName?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/help/asociar_oscilo.reg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FileName !== undefined) {
                localVarQueryParameter['fileName'] = FileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @param {string} [FileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHelpAsociarSigraRegGet: async (FileName?: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/help/asociar_sigra.reg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (FileName !== undefined) {
                localVarQueryParameter['fileName'] = FileName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet: async (FeatureName: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'FeatureName' is not null or undefined
            assertParamExists('featuresGet', 'FeatureName', FeatureName)
            const localVarPath = `/features/{featureName}`
                .replace(`{${"featureName"}}`, encodeURIComponent(String(FeatureName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/features`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga un fichero de medida dado un id
         * @param {number} [IdFicheroMedida] 
         * @param {boolean} [IsCfg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaDownload: async (IdFicheroMedida?: number, IsCfg?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/FicheroMedida/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdFicheroMedida !== undefined) {
                localVarQueryParameter['idFicheroMedida'] = IdFicheroMedida;
            }

            if (IsCfg !== undefined) {
                localVarQueryParameter['isCfg'] = IsCfg;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga el trío de ficheros de medida comprimidos en un .zip dado un id
         * @param {number} [IdFicheroMedida] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaDownloadZip: async (IdFicheroMedida?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/FicheroMedida/downloadZip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IdFicheroMedida !== undefined) {
                localVarQueryParameter['idFicheroMedida'] = IdFicheroMedida;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de los ficheros de medida de un suceso
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaGetBySuceso: async (Id: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('ficheroMedidaGetBySuceso', 'Id', Id)
            const localVarPath = `/api/Commons/Suceso/{id}/ficheros-medida/detalle`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de ficheros de medida compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [IdOscilo] 
         * @param {number} [IdSuceso] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaGetRejilla: async (LoadOptions?: DXLoadOptions, IdOscilo?: number, IdSuceso?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/FicheroMedida/rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdOscilo !== undefined) {
                localVarQueryParameter['idOscilo'] = IdOscilo;
            }

            if (IdSuceso !== undefined) {
                localVarQueryParameter['idSuceso'] = IdSuceso;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una instalacion existente
         * @param {EditInstalacionModel} [EditInstalacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instalacionEdit: async (EditInstalacionModel?: EditInstalacionModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Instalacion/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditInstalacionModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de instalaciones compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instalacionGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Instalacion/rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de instalaciones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instalacionGetTodas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Instalacion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga un fichero adjunto de un oscilo
         * @param {number} Id 
         * @param {number} IdAdjunto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloAttachmentDownload: async (Id: number, IdAdjunto: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('osciloAttachmentDownload', 'Id', Id)
            // verify required parameter 'IdAdjunto' is not null or undefined
            assertParamExists('osciloAttachmentDownload', 'IdAdjunto', IdAdjunto)
            const localVarPath = `/api/Commons/Oscilo/{id}/adjunto/{idAdjunto}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idAdjunto"}}`, encodeURIComponent(String(IdAdjunto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero adjunto de un oscilo
         * @param {number} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloAttachmentUpload: async (Id: number, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('osciloAttachmentUpload', 'Id', Id)
            const localVarPath = `/api/Commons/Oscilo/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si una IP pública y puerto están disponibles
         * @param {string} [IpPublica] 
         * @param {number} [Puerto] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckIpPort: async (IpPublica?: string, Puerto?: number, IdOscilo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/CheckAvailability/IpPort`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IpPublica !== undefined) {
                localVarQueryParameter['IpPublica'] = IpPublica;
            }

            if (Puerto !== undefined) {
                localVarQueryParameter['Puerto'] = Puerto;
            }

            if (IdOscilo !== undefined) {
                localVarQueryParameter['IdOscilo'] = IdOscilo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si una IP pública está disponible
         * @param {string} [IpPublica] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckIpPublica: async (IpPublica?: string, IdOscilo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/CheckAvailability/PublicIP`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (IpPublica !== undefined) {
                localVarQueryParameter['IpPublica'] = IpPublica;
            }

            if (IdOscilo !== undefined) {
                localVarQueryParameter['IdOscilo'] = IdOscilo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un nombre está disponible
         * @param {string} [Nombre] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckNombre: async (Nombre?: string, IdOscilo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/CheckAvailability/Name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (Nombre !== undefined) {
                localVarQueryParameter['Nombre'] = Nombre;
            }

            if (IdOscilo !== undefined) {
                localVarQueryParameter['IdOscilo'] = IdOscilo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un número de serie está disponible
         * @param {string} [NumeroSerie] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckNumeroSerie: async (NumeroSerie?: string, IdOscilo?: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/CheckAvailability/SerialNumber`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (NumeroSerie !== undefined) {
                localVarQueryParameter['NumeroSerie'] = NumeroSerie;
            }

            if (IdOscilo !== undefined) {
                localVarQueryParameter['IdOscilo'] = IdOscilo;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo oscilo
         * @param {CreateOsciloModel} [CreateOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCreate: async (CreateOsciloModel?: CreateOsciloModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateOsciloModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un oscilo existente
         * @param {DeleteOsciloModel} [DeleteOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloDelete: async (DeleteOsciloModel?: DeleteOsciloModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/Eliminar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteOsciloModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un oscilo existente
         * @param {EditOsciloModel} [EditOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloEdit: async (EditOsciloModel?: EditOsciloModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditOsciloModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Encola una nueva petición manual de descarga para un oscilo
         * @param {number} IdOscilo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloEncolarPeticionManualDescarga: async (IdOscilo: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'IdOscilo' is not null or undefined
            assertParamExists('osciloEncolarPeticionManualDescarga', 'IdOscilo', IdOscilo)
            const localVarPath = `/api/Commons/Oscilo/EncolarPeticionManualDescarga/{idOscilo}`
                .replace(`{${"idOscilo"}}`, encodeURIComponent(String(IdOscilo)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de estados de los oscilos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloEstadoTipoGetTodos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/OsciloEstadoTipo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un oscilo dado un id
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloGetDetalle: async (Id: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('osciloGetDetalle', 'Id', Id)
            const localVarPath = `/api/Commons/Oscilo/{id}/detalle`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de oscilos compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Oscilo/rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de regiones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionGetTodas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Region`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de los roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesGetAll: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Descarga un fichero adjunto de un suceso
         * @param {number} Id 
         * @param {number} IdAdjunto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoAttachmentDownload: async (Id: number, IdAdjunto: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('sucesoAttachmentDownload', 'Id', Id)
            // verify required parameter 'IdAdjunto' is not null or undefined
            assertParamExists('sucesoAttachmentDownload', 'IdAdjunto', IdAdjunto)
            const localVarPath = `/api/Commons/Suceso/{id}/adjunto/{idAdjunto}`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)))
                .replace(`{${"idAdjunto"}}`, encodeURIComponent(String(IdAdjunto)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Sube un fichero adjunto de un suceso
         * @param {number} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoAttachmentUpload: async (Id: number, Filename?: string, File?: File, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('sucesoAttachmentUpload', 'Id', Id)
            const localVarPath = `/api/Commons/Suceso/{id}/adjunto`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


        
            // authentication OAuth2 required




            if (Filename !== undefined) { 
                localVarFormParams.append('Filename', Filename as any);
            }
    
            if (File !== undefined) { 
                localVarFormParams.append('File', File as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de categoría de sucesos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoCategoriaTipoGetTodos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/SucesoCategoriaTipo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo suceso
         * @param {CreateSucesoModel} [CreateSucesoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoCreate: async (CreateSucesoModel?: CreateSucesoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suceso`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateSucesoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un suceso existente
         * @param {EditSucesoModel} [EditSucesoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoEdit: async (EditSucesoModel?: EditSucesoModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suceso/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditSucesoModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el detalle de un suceso dado un id
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoGetDetalle: async (Id: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Id' is not null or undefined
            assertParamExists('sucesoGetDetalle', 'Id', Id)
            const localVarPath = `/api/Commons/Suceso/{id}/detalle`
                .replace(`{${"id"}}`, encodeURIComponent(String(Id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de sucesos compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [IdOscilo] 
         * @param {boolean} [Wiki] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoGetRejilla: async (LoadOptions?: DXLoadOptions, IdOscilo?: number, Wiki?: boolean, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Suceso/rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }

            if (IdOscilo !== undefined) {
                localVarQueryParameter['idOscilo'] = IdOscilo;
            }

            if (Wiki !== undefined) {
                localVarQueryParameter['wiki'] = Wiki;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de sucesos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoTipoGetTodos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/SucesoTipo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {number} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckEmail: async (Email: string, IdUsuario: number, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Email' is not null or undefined
            assertParamExists('usuarioCheckEmail', 'Email', Email)
            // verify required parameter 'IdUsuario' is not null or undefined
            assertParamExists('usuarioCheckEmail', 'IdUsuario', IdUsuario)
            const localVarPath = `/api/Commons/Usuario/{Email}/{IdUsuario}/EmailAvailable`
                .replace(`{${"Email"}}`, encodeURIComponent(String(Email)))
                .replace(`{${"IdUsuario"}}`, encodeURIComponent(String(IdUsuario)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckUsername: async (Username: string, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            // verify required parameter 'Username' is not null or undefined
            assertParamExists('usuarioCheckUsername', 'Username', Username)
            const localVarPath = `/api/Commons/Usuario/{Username}/Available`
                .replace(`{${"Username"}}`, encodeURIComponent(String(Username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCreate: async (CreateUserModel?: CreateUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(CreateUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Elimina un usuario existente
         * @param {DeleteUserModel} [DeleteUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioDelete: async (DeleteUserModel?: DeleteUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Eliminar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(DeleteUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioEdit: async (EditUserModel?: EditUserModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditUserModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetCurrentUserProfile: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/me/Profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario/Rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetTodos: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Usuario`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Edita una zona existente
         * @param {EditZonaModel} [EditZonaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonaEdit: async (EditZonaModel?: EditZonaModel, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Zona/Editar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(EditZonaModel, localVarRequestOptions, configuration)

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de zonas compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonaGetRejilla: async (LoadOptions?: DXLoadOptions, options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Zona/rejilla`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required



            if (LoadOptions !== undefined) {
                for (const [key, value] of Object.entries(LoadOptions)) {
					if (value != null) {
						if (typeof value === "object" || Array.isArray(value)) {
							localVarQueryParameter[key] = JSON.stringify(value);
						}
						else {
						  localVarQueryParameter[key] = value;
						}
					}
					else 
						localVarQueryParameter[key] = value;
                }
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
  

         
      
      
        /**
         * 
         * @summary Obtiene una lista de detalles de zonas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonaGetTodas: async (options: ExtendedAxiosRequestConfig = defaultExtendedAxiosRequestConfig): Promise<RequestArgs> => {
            const localVarPath = `/api/Commons/Zona`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


        
            // authentication OAuth2 required




    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            localVarRequestOptions.extensions = {
                
            }
        
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApiApi - functional programming interface
 * @export
 */
export const ApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [FileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHelpAsociarOsciloRegGet(FileName?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHelpAsociarOsciloRegGet(FileName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.apiHelpAsociarOsciloRegGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @param {string} [FileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHelpAsociarSigraRegGet(FileName?: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHelpAsociarSigraRegGet(FileName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.apiHelpAsociarSigraRegGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresGet(FeatureName, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.featuresGet']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async featuresList(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: boolean; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.featuresList(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.featuresList']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga un fichero de medida dado un id
         * @param {number} [IdFicheroMedida] 
         * @param {boolean} [IsCfg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ficheroMedidaDownload(IdFicheroMedida?: number, IsCfg?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ficheroMedidaDownload(IdFicheroMedida, IsCfg, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ficheroMedidaDownload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga el trío de ficheros de medida comprimidos en un .zip dado un id
         * @param {number} [IdFicheroMedida] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ficheroMedidaDownloadZip(IdFicheroMedida?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ficheroMedidaDownloadZip(IdFicheroMedida, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ficheroMedidaDownloadZip']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los ficheros de medida de un suceso
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ficheroMedidaGetBySuceso(Id: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FicheroMedidaDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ficheroMedidaGetBySuceso(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ficheroMedidaGetBySuceso']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de ficheros de medida compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [IdOscilo] 
         * @param {number} [IdSuceso] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async ficheroMedidaGetRejilla(LoadOptions?: DXLoadOptions, IdOscilo?: number, IdSuceso?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.ficheroMedidaGetRejilla(LoadOptions, IdOscilo, IdSuceso, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.ficheroMedidaGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una instalacion existente
         * @param {EditInstalacionModel} [EditInstalacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instalacionEdit(EditInstalacionModel?: EditInstalacionModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instalacionEdit(EditInstalacionModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.instalacionEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de instalaciones compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instalacionGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instalacionGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.instalacionGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de instalaciones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async instalacionGetTodas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InstalacionDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.instalacionGetTodas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.instalacionGetTodas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga un fichero adjunto de un oscilo
         * @param {number} Id 
         * @param {number} IdAdjunto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloAttachmentDownload(Id: number, IdAdjunto: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloAttachmentDownload(Id, IdAdjunto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloAttachmentDownload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero adjunto de un oscilo
         * @param {number} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloAttachmentUpload(Id: number, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloAttachmentUpload(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloAttachmentUpload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si una IP pública y puerto están disponibles
         * @param {string} [IpPublica] 
         * @param {number} [Puerto] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloCheckIpPort(IpPublica?: string, Puerto?: number, IdOscilo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloCheckIpPort(IpPublica, Puerto, IdOscilo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloCheckIpPort']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si una IP pública está disponible
         * @param {string} [IpPublica] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloCheckIpPublica(IpPublica?: string, IdOscilo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloCheckIpPublica(IpPublica, IdOscilo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloCheckIpPublica']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un nombre está disponible
         * @param {string} [Nombre] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloCheckNombre(Nombre?: string, IdOscilo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloCheckNombre(Nombre, IdOscilo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloCheckNombre']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un número de serie está disponible
         * @param {string} [NumeroSerie] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloCheckNumeroSerie(NumeroSerie?: string, IdOscilo?: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloCheckNumeroSerie(NumeroSerie, IdOscilo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloCheckNumeroSerie']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo oscilo
         * @param {CreateOsciloModel} [CreateOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloCreate(CreateOsciloModel?: CreateOsciloModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloCreate(CreateOsciloModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un oscilo existente
         * @param {DeleteOsciloModel} [DeleteOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloDelete(DeleteOsciloModel?: DeleteOsciloModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloDelete(DeleteOsciloModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un oscilo existente
         * @param {EditOsciloModel} [EditOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloEdit(EditOsciloModel?: EditOsciloModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloEdit(EditOsciloModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Encola una nueva petición manual de descarga para un oscilo
         * @param {number} IdOscilo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloEncolarPeticionManualDescarga(IdOscilo: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloEncolarPeticionManualDescarga(IdOscilo, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloEncolarPeticionManualDescarga']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de estados de los oscilos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloEstadoTipoGetTodos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsciloEstadoTipoDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloEstadoTipoGetTodos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloEstadoTipoGetTodos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un oscilo dado un id
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloGetDetalle(Id: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OsciloDetalleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloGetDetalle(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloGetDetalle']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de oscilos compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async osciloGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.osciloGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.osciloGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de regiones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async regionGetTodas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegionDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.regionGetTodas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.regionGetTodas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesGetAll(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RolesRmListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesGetAll(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.rolesGetAll']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Descarga un fichero adjunto de un suceso
         * @param {number} Id 
         * @param {number} IdAdjunto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoAttachmentDownload(Id: number, IdAdjunto: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoAttachmentDownload(Id, IdAdjunto, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoAttachmentDownload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Sube un fichero adjunto de un suceso
         * @param {number} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoAttachmentUpload(Id: number, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoAttachmentUpload(Id, Filename, File, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoAttachmentUpload']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de categoría de sucesos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoCategoriaTipoGetTodos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SucesoCategoriaTipoDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoCategoriaTipoGetTodos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoCategoriaTipoGetTodos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo suceso
         * @param {CreateSucesoModel} [CreateSucesoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoCreate(CreateSucesoModel?: CreateSucesoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoCreate(CreateSucesoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un suceso existente
         * @param {EditSucesoModel} [EditSucesoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoEdit(EditSucesoModel?: EditSucesoModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoEdit(EditSucesoModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el detalle de un suceso dado un id
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoGetDetalle(Id: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SucesoDetalleModelResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoGetDetalle(Id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoGetDetalle']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de sucesos compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [IdOscilo] 
         * @param {boolean} [Wiki] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoGetRejilla(LoadOptions?: DXLoadOptions, IdOscilo?: number, Wiki?: boolean, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoGetRejilla(LoadOptions, IdOscilo, Wiki, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de sucesos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sucesoTipoGetTodos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SucesoTipoDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sucesoTipoGetTodos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.sucesoTipoGetTodos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {number} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCheckEmail(Email: string, IdUsuario: number, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCheckEmail(Email, IdUsuario, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCheckEmail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCheckUsername(Username: string, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCheckUsername(Username, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCheckUsername']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioCreate(CreateUserModel?: CreateUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioCreate(CreateUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioCreate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Elimina un usuario existente
         * @param {DeleteUserModel} [DeleteUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioDelete(DeleteUserModel?: DeleteUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioDelete(DeleteUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioDelete']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioEdit(EditUserModel?: EditUserModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioEdit(EditUserModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGetCurrentUserProfile(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileResponseResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGetCurrentUserProfile(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGetCurrentUserProfile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usuarioGetTodos(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsuarioDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usuarioGetTodos(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.usuarioGetTodos']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Edita una zona existente
         * @param {EditZonaModel} [EditZonaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonaEdit(EditZonaModel?: EditZonaModel, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ObjectResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonaEdit(EditZonaModel, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.zonaEdit']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de zonas compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonaGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoadResultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonaGetRejilla(LoadOptions, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.zonaGetRejilla']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de zonas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonaGetTodas(options?: ExtendedAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ZonaDetalleModelListResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonaGetTodas(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ApiApi.zonaGetTodas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ApiApi - factory interface
 * @export
 */
export const ApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApiApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [FileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHelpAsociarOsciloRegGet(FileName?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiHelpAsociarOsciloRegGet(FileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [FileName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHelpAsociarSigraRegGet(FileName?: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiHelpAsociarSigraRegGet(FileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene valor de activación de una feature
         * @param {string} FeatureName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresGet(FeatureName: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.featuresGet(FeatureName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene la lista de feature flags y valor de activación
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        featuresList(options?: any): AxiosPromise<{ [key: string]: boolean; }> {
            return localVarFp.featuresList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga un fichero de medida dado un id
         * @param {number} [IdFicheroMedida] 
         * @param {boolean} [IsCfg] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaDownload(IdFicheroMedida?: number, IsCfg?: boolean, options?: any): AxiosPromise<File> {
            return localVarFp.ficheroMedidaDownload(IdFicheroMedida, IsCfg, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga el trío de ficheros de medida comprimidos en un .zip dado un id
         * @param {number} [IdFicheroMedida] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaDownloadZip(IdFicheroMedida?: number, options?: any): AxiosPromise<File> {
            return localVarFp.ficheroMedidaDownloadZip(IdFicheroMedida, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los ficheros de medida de un suceso
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaGetBySuceso(Id: number, options?: any): AxiosPromise<FicheroMedidaDetalleModelListResponseDTO> {
            return localVarFp.ficheroMedidaGetBySuceso(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de ficheros de medida compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [IdOscilo] 
         * @param {number} [IdSuceso] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ficheroMedidaGetRejilla(LoadOptions?: DXLoadOptions, IdOscilo?: number, IdSuceso?: number, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.ficheroMedidaGetRejilla(LoadOptions, IdOscilo, IdSuceso, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una instalacion existente
         * @param {EditInstalacionModel} [EditInstalacionModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instalacionEdit(EditInstalacionModel?: EditInstalacionModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.instalacionEdit(EditInstalacionModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de instalaciones compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instalacionGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.instalacionGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de instalaciones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        instalacionGetTodas(options?: any): AxiosPromise<InstalacionDetalleModelListResponseDTO> {
            return localVarFp.instalacionGetTodas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga un fichero adjunto de un oscilo
         * @param {number} Id 
         * @param {number} IdAdjunto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloAttachmentDownload(Id: number, IdAdjunto: number, options?: any): AxiosPromise<File> {
            return localVarFp.osciloAttachmentDownload(Id, IdAdjunto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero adjunto de un oscilo
         * @param {number} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloAttachmentUpload(Id: number, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.osciloAttachmentUpload(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si una IP pública y puerto están disponibles
         * @param {string} [IpPublica] 
         * @param {number} [Puerto] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckIpPort(IpPublica?: string, Puerto?: number, IdOscilo?: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.osciloCheckIpPort(IpPublica, Puerto, IdOscilo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si una IP pública está disponible
         * @param {string} [IpPublica] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckIpPublica(IpPublica?: string, IdOscilo?: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.osciloCheckIpPublica(IpPublica, IdOscilo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un nombre está disponible
         * @param {string} [Nombre] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckNombre(Nombre?: string, IdOscilo?: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.osciloCheckNombre(Nombre, IdOscilo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un número de serie está disponible
         * @param {string} [NumeroSerie] 
         * @param {number} [IdOscilo] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCheckNumeroSerie(NumeroSerie?: string, IdOscilo?: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.osciloCheckNumeroSerie(NumeroSerie, IdOscilo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo oscilo
         * @param {CreateOsciloModel} [CreateOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloCreate(CreateOsciloModel?: CreateOsciloModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.osciloCreate(CreateOsciloModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un oscilo existente
         * @param {DeleteOsciloModel} [DeleteOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloDelete(DeleteOsciloModel?: DeleteOsciloModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.osciloDelete(DeleteOsciloModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un oscilo existente
         * @param {EditOsciloModel} [EditOsciloModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloEdit(EditOsciloModel?: EditOsciloModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.osciloEdit(EditOsciloModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Encola una nueva petición manual de descarga para un oscilo
         * @param {number} IdOscilo 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloEncolarPeticionManualDescarga(IdOscilo: number, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.osciloEncolarPeticionManualDescarga(IdOscilo, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de estados de los oscilos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloEstadoTipoGetTodos(options?: any): AxiosPromise<OsciloEstadoTipoDetalleModelListResponseDTO> {
            return localVarFp.osciloEstadoTipoGetTodos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un oscilo dado un id
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloGetDetalle(Id: number, options?: any): AxiosPromise<OsciloDetalleModelResponseDTO> {
            return localVarFp.osciloGetDetalle(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de oscilos compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        osciloGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.osciloGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de regiones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        regionGetTodas(options?: any): AxiosPromise<RegionDetalleModelListResponseDTO> {
            return localVarFp.regionGetTodas(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los roles del sistema
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesGetAll(options?: any): AxiosPromise<RolesRmListResponseDTO> {
            return localVarFp.rolesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Descarga un fichero adjunto de un suceso
         * @param {number} Id 
         * @param {number} IdAdjunto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoAttachmentDownload(Id: number, IdAdjunto: number, options?: any): AxiosPromise<File> {
            return localVarFp.sucesoAttachmentDownload(Id, IdAdjunto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sube un fichero adjunto de un suceso
         * @param {number} Id 
         * @param {string} [Filename] 
         * @param {File} [File] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoAttachmentUpload(Id: number, Filename?: string, File?: File, options?: any): AxiosPromise<StringResponseDTO> {
            return localVarFp.sucesoAttachmentUpload(Id, Filename, File, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de categoría de sucesos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoCategoriaTipoGetTodos(options?: any): AxiosPromise<SucesoCategoriaTipoDetalleModelListResponseDTO> {
            return localVarFp.sucesoCategoriaTipoGetTodos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo suceso
         * @param {CreateSucesoModel} [CreateSucesoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoCreate(CreateSucesoModel?: CreateSucesoModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.sucesoCreate(CreateSucesoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un suceso existente
         * @param {EditSucesoModel} [EditSucesoModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoEdit(EditSucesoModel?: EditSucesoModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.sucesoEdit(EditSucesoModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el detalle de un suceso dado un id
         * @param {number} Id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoGetDetalle(Id: number, options?: any): AxiosPromise<SucesoDetalleModelResponseDTO> {
            return localVarFp.sucesoGetDetalle(Id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de sucesos compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {number} [IdOscilo] 
         * @param {boolean} [Wiki] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoGetRejilla(LoadOptions?: DXLoadOptions, IdOscilo?: number, Wiki?: boolean, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.sucesoGetRejilla(LoadOptions, IdOscilo, Wiki, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de los tipos de sucesos
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sucesoTipoGetTodos(options?: any): AxiosPromise<SucesoTipoDetalleModelListResponseDTO> {
            return localVarFp.sucesoTipoGetTodos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un email de usuario está disponible
         * @param {string} Email 
         * @param {number} IdUsuario 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckEmail(Email: string, IdUsuario: number, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.usuarioCheckEmail(Email, IdUsuario, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Determina si un nombre de usuario está disponible
         * @param {string} Username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCheckUsername(Username: string, options?: any): AxiosPromise<BooleanResponseDTO> {
            return localVarFp.usuarioCheckUsername(Username, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Crea un nuevo usuario
         * @param {CreateUserModel} [CreateUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioCreate(CreateUserModel?: CreateUserModel, options?: any): AxiosPromise<Int32ResponseDTO> {
            return localVarFp.usuarioCreate(CreateUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Elimina un usuario existente
         * @param {DeleteUserModel} [DeleteUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioDelete(DeleteUserModel?: DeleteUserModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.usuarioDelete(DeleteUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita un usuario existente
         * @param {EditUserModel} [EditUserModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioEdit(EditUserModel?: EditUserModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.usuarioEdit(EditUserModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene el perfil del usuario actual
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetCurrentUserProfile(options?: any): AxiosPromise<UserProfileResponseResponseDTO> {
            return localVarFp.usuarioGetCurrentUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de usuarios compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.usuarioGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de usuarios
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usuarioGetTodos(options?: any): AxiosPromise<UsuarioDetalleModelListResponseDTO> {
            return localVarFp.usuarioGetTodos(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edita una zona existente
         * @param {EditZonaModel} [EditZonaModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonaEdit(EditZonaModel?: EditZonaModel, options?: any): AxiosPromise<ObjectResponseDTO> {
            return localVarFp.zonaEdit(EditZonaModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de zonas compatible con DexExtreme
         * @param {DXLoadOptions} [LoadOptions] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonaGetRejilla(LoadOptions?: DXLoadOptions, options?: any): AxiosPromise<LoadResultResponseDTO> {
            return localVarFp.zonaGetRejilla(LoadOptions, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Obtiene una lista de detalles de zonas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonaGetTodas(options?: any): AxiosPromise<ZonaDetalleModelListResponseDTO> {
            return localVarFp.zonaGetTodas(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApiApi - object-oriented interface
 * @export
 * @class ApiApi
 * @extends {BaseAPI}
 */
export class ApiApi extends BaseAPI {
    /**
     * 
     * @param {string} [FileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiHelpAsociarOsciloRegGet(FileName?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiHelpAsociarOsciloRegGet(FileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [FileName] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public apiHelpAsociarSigraRegGet(FileName?: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).apiHelpAsociarSigraRegGet(FileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene valor de activación de una feature
     * @param {string} FeatureName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public featuresGet(FeatureName: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).featuresGet(FeatureName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene la lista de feature flags y valor de activación
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public featuresList(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).featuresList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga un fichero de medida dado un id
     * @param {number} [IdFicheroMedida] 
     * @param {boolean} [IsCfg] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ficheroMedidaDownload(IdFicheroMedida?: number, IsCfg?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ficheroMedidaDownload(IdFicheroMedida, IsCfg, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga el trío de ficheros de medida comprimidos en un .zip dado un id
     * @param {number} [IdFicheroMedida] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ficheroMedidaDownloadZip(IdFicheroMedida?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ficheroMedidaDownloadZip(IdFicheroMedida, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de los ficheros de medida de un suceso
     * @param {number} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ficheroMedidaGetBySuceso(Id: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ficheroMedidaGetBySuceso(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de ficheros de medida compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {number} [IdOscilo] 
     * @param {number} [IdSuceso] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public ficheroMedidaGetRejilla(LoadOptions?: DXLoadOptions, IdOscilo?: number, IdSuceso?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).ficheroMedidaGetRejilla(LoadOptions, IdOscilo, IdSuceso, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una instalacion existente
     * @param {EditInstalacionModel} [EditInstalacionModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public instalacionEdit(EditInstalacionModel?: EditInstalacionModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).instalacionEdit(EditInstalacionModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de instalaciones compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public instalacionGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).instalacionGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de instalaciones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public instalacionGetTodas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).instalacionGetTodas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga un fichero adjunto de un oscilo
     * @param {number} Id 
     * @param {number} IdAdjunto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloAttachmentDownload(Id: number, IdAdjunto: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloAttachmentDownload(Id, IdAdjunto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero adjunto de un oscilo
     * @param {number} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloAttachmentUpload(Id: number, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloAttachmentUpload(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si una IP pública y puerto están disponibles
     * @param {string} [IpPublica] 
     * @param {number} [Puerto] 
     * @param {number} [IdOscilo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloCheckIpPort(IpPublica?: string, Puerto?: number, IdOscilo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloCheckIpPort(IpPublica, Puerto, IdOscilo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si una IP pública está disponible
     * @param {string} [IpPublica] 
     * @param {number} [IdOscilo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloCheckIpPublica(IpPublica?: string, IdOscilo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloCheckIpPublica(IpPublica, IdOscilo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un nombre está disponible
     * @param {string} [Nombre] 
     * @param {number} [IdOscilo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloCheckNombre(Nombre?: string, IdOscilo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloCheckNombre(Nombre, IdOscilo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un número de serie está disponible
     * @param {string} [NumeroSerie] 
     * @param {number} [IdOscilo] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloCheckNumeroSerie(NumeroSerie?: string, IdOscilo?: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloCheckNumeroSerie(NumeroSerie, IdOscilo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo oscilo
     * @param {CreateOsciloModel} [CreateOsciloModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloCreate(CreateOsciloModel?: CreateOsciloModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloCreate(CreateOsciloModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un oscilo existente
     * @param {DeleteOsciloModel} [DeleteOsciloModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloDelete(DeleteOsciloModel?: DeleteOsciloModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloDelete(DeleteOsciloModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un oscilo existente
     * @param {EditOsciloModel} [EditOsciloModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloEdit(EditOsciloModel?: EditOsciloModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloEdit(EditOsciloModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Encola una nueva petición manual de descarga para un oscilo
     * @param {number} IdOscilo 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloEncolarPeticionManualDescarga(IdOscilo: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloEncolarPeticionManualDescarga(IdOscilo, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de los tipos de estados de los oscilos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloEstadoTipoGetTodos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloEstadoTipoGetTodos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un oscilo dado un id
     * @param {number} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloGetDetalle(Id: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloGetDetalle(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de oscilos compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public osciloGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).osciloGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de regiones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public regionGetTodas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).regionGetTodas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de los roles del sistema
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public rolesGetAll(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).rolesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Descarga un fichero adjunto de un suceso
     * @param {number} Id 
     * @param {number} IdAdjunto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoAttachmentDownload(Id: number, IdAdjunto: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoAttachmentDownload(Id, IdAdjunto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sube un fichero adjunto de un suceso
     * @param {number} Id 
     * @param {string} [Filename] 
     * @param {File} [File] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoAttachmentUpload(Id: number, Filename?: string, File?: File, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoAttachmentUpload(Id, Filename, File, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de los tipos de categoría de sucesos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoCategoriaTipoGetTodos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoCategoriaTipoGetTodos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo suceso
     * @param {CreateSucesoModel} [CreateSucesoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoCreate(CreateSucesoModel?: CreateSucesoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoCreate(CreateSucesoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un suceso existente
     * @param {EditSucesoModel} [EditSucesoModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoEdit(EditSucesoModel?: EditSucesoModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoEdit(EditSucesoModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el detalle de un suceso dado un id
     * @param {number} Id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoGetDetalle(Id: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoGetDetalle(Id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de sucesos compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {number} [IdOscilo] 
     * @param {boolean} [Wiki] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoGetRejilla(LoadOptions?: DXLoadOptions, IdOscilo?: number, Wiki?: boolean, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoGetRejilla(LoadOptions, IdOscilo, Wiki, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de los tipos de sucesos
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public sucesoTipoGetTodos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).sucesoTipoGetTodos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un email de usuario está disponible
     * @param {string} Email 
     * @param {number} IdUsuario 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCheckEmail(Email: string, IdUsuario: number, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCheckEmail(Email, IdUsuario, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Determina si un nombre de usuario está disponible
     * @param {string} Username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCheckUsername(Username: string, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCheckUsername(Username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Crea un nuevo usuario
     * @param {CreateUserModel} [CreateUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioCreate(CreateUserModel?: CreateUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioCreate(CreateUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Elimina un usuario existente
     * @param {DeleteUserModel} [DeleteUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioDelete(DeleteUserModel?: DeleteUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioDelete(DeleteUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita un usuario existente
     * @param {EditUserModel} [EditUserModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioEdit(EditUserModel?: EditUserModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioEdit(EditUserModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene el perfil del usuario actual
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGetCurrentUserProfile(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGetCurrentUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de usuarios compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de usuarios
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public usuarioGetTodos(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).usuarioGetTodos(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edita una zona existente
     * @param {EditZonaModel} [EditZonaModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public zonaEdit(EditZonaModel?: EditZonaModel, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).zonaEdit(EditZonaModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de zonas compatible con DexExtreme
     * @param {DXLoadOptions} [LoadOptions] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public zonaGetRejilla(LoadOptions?: DXLoadOptions, options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).zonaGetRejilla(LoadOptions, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Obtiene una lista de detalles de zonas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApiApi
     */
    public zonaGetTodas(options?: ExtendedAxiosRequestConfig) {
        return ApiApiFp(this.configuration).zonaGetTodas(options).then((request) => request(this.axios, this.basePath));
    }
}



